import { render, staticRenderFns } from "./OpenTicketsPanel.vue?vue&type=template&id=ee79dc74&scoped=true"
import script from "./OpenTicketsPanel.vue?vue&type=script&lang=js"
export * from "./OpenTicketsPanel.vue?vue&type=script&lang=js"
import style0 from "./OpenTicketsPanel.vue?vue&type=style&index=0&id=ee79dc74&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee79dc74",
  null
  
)

export default component.exports